import { styled } from '@mui/material';

export const PageW = styled('div')`
  width: 100%;

  @media (max-width: 1023px) {
    padding: 16px 16px 96px 16px;
  }
`;

export const ContainerW = styled('div')`
  margin: 170px auto 0;
  max-width: 850px;
  @media (max-width: 1023px) {
    margin-top: 0px;
  }
`;

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  width: 507px;
  min-width: 507px;
  margin-right: 48px;
  @media (max-width: 1023px) {
    width: 100%;
    min-width: 0px;
  }
`;
